<div *ngIf="detailBavs && ! (modeRendu.enModeImpression$ | async)">
<div class="body">
    <div class="form-row mx-2 pb-3" *ngIf="detailBavs">
      <div class="col" [formGroup]="rootForm">
        <div class="form-row">
          <div class="col-md-6 titreBav mx-1 mt-3">
            Nombre de BAV actuellement : <b>{{detailBavs.length}}</b>
          </div>
        </div>
        <div class="card-header text-muted mt-5">
          <i>Renseigner les informations suivantes pour chacun des BAV dans lesquels l'association est intervenue durant
            l'année
          </i>
        </div>
        <div>
          <mat-accordion class=" col-12">
            <div *ngFor="let item of detailBavs.controls; let i = index">
              <mat-expansion-panel (opened)="setStep(i)">
                <mat-expansion-panel-header>
                  <mat-panel-description>
                    <mat-icon>account_circle</mat-icon>&#xA0;
                    <span [ngClass]="{'onglet-invalide': detailBavs.controls[i].invalid}">
                      BAV {{ i + 1 }}
                    </span>
                    <span *ngIf="detailBavs.controls[i].get('bavIelst').value">
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>{{ this.gestionLibelle(detailBavs.controls[i].get('bavIelst').value) }}</b>
                    </span>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                  <h4 class="ml-2 pt-3">F.1 - Les moyens (BAV)</h4>
                  <h5 class="mt-4 ml-2">F.1.1 - Les personnels de l'association en charge des activités de l'Aide Aux
                    Victimes (tous dispositifs AAV)</h5>
                  <div class="alerteTableau pt-2 pb-2">
                    Ce tableau est en lien avec les tableaux A.1.a, A.1.b, A.1.c de la section A.1 de l'onglet ‘A – Les moyens’
                  </div>
                  <div class="card-header text-muted">
                    <i>Renseigner, pour chacune des fonctions, et selon le statut des personnels AAV, le nombre de
                      personnes en poste au 31 décembre ainsi que leur temps
                      de travail en équivalent temps plein travaillé (ETPT) sur l'année
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th rowspan="2" class="text-center align-middle">Fonction</th>
                                <th colspan="2" class="text-center align-middle">au sein du BAV</th>
                              </tr>
                              <tr>
                                <th class="text-center align-middle">Effectif 31/12</th>
                                <th class="text-center align-middle">ETPT</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Accueillants Aide Aux Victimes</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="999"
                                    label="bavAaNbAav" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-float-mask-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" 
                                      separatorLimit="999" libelle="vide" 
                                      label="bavAaEtpAav"
                                      classeSupplInput="text-right">
                                  </bis-float-mask-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Juristes</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="999"
                                    label="bavAaNbJur" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-float-mask-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" 
                                      separatorLimit="999" libelle="vide" 
                                      label="bavAaEtpJur"
                                      classeSupplInput="text-right">
                                  </bis-float-mask-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Psychologues</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="999"
                                    label="bavAaNbPsy" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-float-mask-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" 
                                      separatorLimit="999" libelle="vide" 
                                      label="bavAaEtpPsy"
                                      classeSupplInput="text-right">
                                  </bis-float-mask-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Travailleurs sociaux</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="999"
                                    label="bavAaNbWsoc" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-float-mask-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" 
                                      separatorLimit="999" libelle="vide" 
                                      label="bavAaEtpWsoc"
                                      classeSupplInput="text-right">
                                  </bis-float-mask-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autres intervenants</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="999"
                                    label="bavAaNbAutrInterv" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-float-mask-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" 
                                      separatorLimit="999" libelle="vide" 
                                      label="bavAaEtpAutrInterv"
                                      classeSupplInput="text-right">
                                  </bis-float-mask-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Directeur, chef de service
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="999"
                                    label="bavAaNbDir" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-float-mask-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" 
                                      separatorLimit="999" libelle="vide" 
                                      label="bavAaEtpDir"
                                      classeSupplInput="text-right">
                                  </bis-float-mask-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Comptable, secrétaire,
                                  personnel d'entretien</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="999"
                                    label="bavAaNbComptsecr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-float-mask-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" 
                                      separatorLimit="999" libelle="vide" 
                                      label="bavAaEtpComptsecr"
                                      classeSupplInput="text-right">
                                  </bis-float-mask-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autres fonctions
                                  transversales et de support (ex : informaticien)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="999"
                                    label="bavAaNbAutrSupport" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-float-mask-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" 
                                      separatorLimit="999" libelle="vide" 
                                      label="bavAaEtpAutrSupport"
                                      classeSupplInput="text-right">
                                  </bis-float-mask-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL des personnels du BAV</b>
                                  <span *ngIf="modeRendu.enModeSaisie$ | async">
                                    <button class="btn-info ml-1 mr-2"
                                      title="Calcul automatique du total à partir des données ventilées"
                                      (click)="calculTotalTableauBavF11(i)">
                                      <b><i>Calcul automatique</i></b>
                                    </button>
                                  </span>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="9999"
                                    label="bavAaNbTot" classeSupplementaire="integer-input-total text-right"
                                    libelle="vide" [erreursCroisees]="['ctrlF1Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                     labelErreur="ctrlF1Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF1Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-float-mask-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" 
                                      separatorLimit="9999" libelle="vide" 
                                      label="bavAaEtpTot"
                                      classeSupplInput="integer-input-total text-right" [erreursCroisees]="['ctrlF2Bav']">
                                  </bis-float-mask-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF2Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF2Bav_' + i"></bis-affiche-alertes>
                                  <bis-affiche-alertes [labelAlerte]="'alertF49Bav_' + i"></bis-affiche-alertes>
                                 </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <h4 class="ml-2 mt-5">F.2 - Les premiers contacts (BAV)</h4>
                  <h5 class="mt-4 ml-2">F.2.1 - L'origine du premier contact (victime ou non)</h5>
                  <div class="alerteTableau pt-2 pb-2">
                    Ce tableau est en lien avec le tableau B.1 de l'onglet ‘B – Les premiers contacts’
                  </div>
                  <div class="card-header text-muted">
                    <i>Indiquer le nombre de personnes en contact avec l'association au sein du BAV pour la première
                      fois au cours de l'année, <u>qu'elles soient ou non victimes</u>, selon l'origine du premier
                      contact
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th class="text-center align-middle">Origine du contact</th>
                                <th class="text-center align-middle">au sein du BAV</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Démarche pro-active de
                                  l'association vers la personne</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavBbPremContactOrigAsso" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">A l'initiative de la personne
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavBbPremContactOrigPerso" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL du BAV</b>
                                  <span *ngIf="modeRendu.enModeSaisie$ | async">
                                    <button class="btn-info ml-1 mr-2"
                                      title="Calcul automatique du total à partir des données ventilées"
                                      (click)="calculTotalTableauBavF21(i)">
                                      <b><i>Calcul automatique</i></b>
                                    </button>
                                  </span>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavBbPremContactOrigTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF3Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF3Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF3Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <h5 class="mt-5 ml-2">F.2.2 - Le mode de premier contact (victime ou non)</h5>
                  <div class="alerteTableau pt-2 pb-2">
                    Ce tableau est en lien avec le tableau B.2 de l'onglet ‘B – Les premiers contacts’
                  </div>
                  <div class="card-header text-muted">
                    <i>Indiquer le nombre de personnes en contact avec l'association pour la première fois au cours de
                      l'année, <u>qu'elles soient ou non victimes</u>, selon le mode de premier contact
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th class="text-center align-middle">Mode de contact</th>
                                <th class="text-center align-middle">au sein du BAV</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Courrier, courriel ou fax
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavBbPremContactModeEcrit" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Appel téléphonique</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavBbPremContactModeTel" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Présentation à la permanence
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavBbPremContactModePres" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL du BAV</b>
                                  <span *ngIf="modeRendu.enModeSaisie$ | async">
                                    <button class="btn-info ml-1 mr-2"
                                      title="Calcul automatique du total à partir des données ventilées"
                                      (click)="calculTotalTableauBavF22(i)">
                                      <b><i>Calcul automatique</i></b>
                                    </button>
                                  </span>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavBbPremContactModeTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF4Bav', 'ctrlF23Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF4Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF23Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF4Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <h4 class="ml-2 mt-5">F.3 - Les personnes reçues (BAV)</h4>
                  <h5 class="mt-4 ml-2">F.3.1 - Personnes reçues pour soutien et accompagnement</h5>
                  <div class="alerteTableau pt-2 pb-2">
                    Ce tableau est en lien avec le tableau C.1 de l'onglet ‘C – Les personnes reçues’
                  </div>
                  <div class="card-header text-muted">
                    <i>Indiquer le nombre de personnes reçues selon la nature des faits
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th rowspan="2" class="text-center align-middle">Nature des faits</th>
                                <th colspan="3" class="text-center align-middle">Au sein du BAV</th>
                              </tr>
                              <tr>
                                <th class="text-center align-middle">Nombre de personnes reçues</th>
                                <th class="text-center align-middle">Dont accompagnées (au moins 2 entretiens)</th>
                                <th class="text-center align-middle">Nombre d'entretiens réalisés</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Faits pouvant avoir une
                                  qualification pénale</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavCcRecuVictNb" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavCcRecuVictSuivi" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlF24Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF24Bav">
                                  </bis-affiche-erreurs-croisees>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavCcRecuVictEntret" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlF26Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF26Bav">
                                  </bis-affiche-erreurs-croisees>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Faits n'ayant pas une
                                  qualification pénale</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavCcRecuNvictNb" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavCcRecuNvictSuivi" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlF25Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF25Bav">
                                  </bis-affiche-erreurs-croisees>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavCcRecuNvictEntret" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlF27Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF27Bav">
                                  </bis-affiche-erreurs-croisees>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL</b>
                                  <span *ngIf="modeRendu.enModeSaisie$ | async">
                                    <button class="btn-info ml-1 mr-2"
                                      title="Calcul automatique du total à partir des données ventilées"
                                      (click)="calculTotalTableauBavF31(i)">
                                      <b><i>Calcul automatique</i></b>
                                    </button>
                                  </span>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavCcRecuNbTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF5Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF5Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF5Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavCcRecuSuiviTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF6Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF6Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF6Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavCcRecuEntretTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF7Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF7Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF7Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <h5 class="mt-5 ml-2">F.3.2 - Nombre de victimes <u>d'infractions pénales</u> reçues au BAV</h5>
                  <div class="alerteTableau pt-2 pb-2">
                    Ce tableau est en lien avec le tableau C.2 de l'onglet ‘C – Les personnes reçues’
                  </div>
                  <div class="card-header text-muted">
                    <i>Indiquer le nombre de victimes reçues selon les précisions demandées
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row mt-2">
                        <div class="col-md-10">
                          <bis-integer-inline-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                            label="bavCcRecuVict" classeColLabel="col-6" classeLabelErreur="col-3" classeColInput="col-3"
                            classeSupplInput="text-right" [erreursCroisees]="['ctrlF28Bav']">
                          </bis-integer-inline-input-keypad>
                          <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                            labelErreur="ctrlF28Bav">
                          </bis-affiche-erreurs-croisees>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                          <bis-integer-inline-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                            label="bavCcRecuVictPc" classeColLabel="col-9" classeColInput="col-3"
                            classeSupplInput="text-right" [erreursCroisees]="['ctrlF29Bav']">
                          </bis-integer-inline-input-keypad>
                          <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                            labelErreur="ctrlF29Bav">
                          </bis-affiche-erreurs-croisees>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                          <bis-integer-inline-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                            label="bavCcRecuVictAud" classeColLabel="col-9" classeColInput="col-3"
                            classeSupplInput="text-right" [erreursCroisees]="['ctrlF30Bav']">
                          </bis-integer-inline-input-keypad>
                          <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                            labelErreur="ctrlF30Bav">
                          </bis-affiche-erreurs-croisees>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <h4 class="ml-2 mt-5">F.4 - Contexte juridique des faits pour les victimes d'infractions pénales</h4>
                  <div class="alerteTableau pt-2">
                    Ce tableau est en lien avec le tableau D.1 de l'onglet ‘D – Les faits – procédure’
                  </div>
                  <div class="card-header text-muted mt-3">
                    <i>Indiquer la qualification pénale des faits pour lesquels la victime a été reçue durant
                      l'année<br>
                      En cas d'infractions multiples ne retenir que l'infraction principale subie par la victime
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th class="text-center align-middle">Infractions selon le contexte des faits</th>
                                <th class="text-center align-middle">Nombre de victimes reçues au sein du BAV</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%"><b>1 - Atteintes aux
                                    personnes (hors accidents de la circulation)</b></td>
                                <td class="text-center align-middle pt-3" style="width: 15%"></td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Homicides volontaires</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoHomiVolo" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Infractions à caractère
                                  sexuel (viols, agressions sexuelles, atteintes et harcèlements sexuels)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoSexuel" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Proxénétisme</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoProxe" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Violences volontaires</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoViolen" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Homicides involontaires</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoHomiInvolo" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Blessures involontaires</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoBless" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Abandons de famille (non
                                  paiement de la CEE, non représentation d'enfants...)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoAband" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Menaces, injures, harcèlement
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoMenace" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Discriminations</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoDiscri" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autre(s)<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    label="bavDdFaitPersoAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF26Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> Total atteintes aux personnes</b>
                                  <span *ngIf="modeRendu.enModeSaisie$ | async">
                                    <button class="btn-info ml-1 mr-2"
                                      title="Calcul automatique du total à partir des données ventilées"
                                      (click)="calculTotalTableauBavF42(i)">
                                      <b><i>Calcul automatique</i></b>
                                    </button>
                                  </span>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavDdFaitPersoTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF8Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF8Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF8Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%"><b>2 - Atteintes aux biens
                                    (hors accidents de la circulation)</b></td>
                                <td class="text-center align-middle pt-3" style="width: 15%"></td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Vol simple</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitBienVolSimp" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Vol aggravé</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitBienVolAggr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Abus de confiance,
                                  escroquerie</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitBienEscro" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Destruction, dégradation</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitBienDegrad" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autre(s)<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    label="bavDdFaitBienAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF27Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitBienAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> Total atteintes aux biens</b>
                                  <span *ngIf="modeRendu.enModeSaisie$ | async">
                                    <button class="btn-info ml-1 mr-2"
                                      title="Calcul automatique du total à partir des données ventilées"
                                      (click)="calculTotalTableauBavF43(i)">
                                      <b><i>Calcul automatique</i></b>
                                    </button>
                                  </span>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavDdFaitBienTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF9Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF9Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF9Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%"><b>3 - Accidents de la circulation</b></td>
                                <td class="text-center align-middle pt-3" style="width: 15%"></td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Homicides involontaires, blessures involontaires</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitCircuBless" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Dégâts matériels uniquement</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitCircuDegat" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> Total accidents de la circulation</b>
                                  <span *ngIf="modeRendu.enModeSaisie$ | async">
                                    <button class="btn-info ml-1 mr-2"
                                      title="Calcul automatique du total à partir des données ventilées"
                                      (click)="calculTotalTableauBavF44(i)">
                                      <b><i>Calcul automatique</i></b>
                                    </button>
                                  </span>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavDdFaitCircuTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF10Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF10Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF10Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%"><b>4 - Autres infractions</b><br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    label="bavDdFaitAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF28Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> Total des victimes reçues</b>
                                  <span *ngIf="modeRendu.enModeSaisie$ | async">
                                    <button class="btn-info ml-1 mr-2"
                                      title="Calcul automatique du total à partir des données ventilées"
                                      (click)="calculTotalTableauBavF41(i)">
                                      <b><i>Calcul automatique</i></b>
                                    </button>
                                  </span>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavDdFaitTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF11Bav', 'ctrlF31Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF11Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF31Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF11Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <h4 class="ml-2 mt-5">F.5 - Les aides apportées par l'association</h4>
                  <h5 class="mt-4 ml-2">F.5.1 - Les entretiens réalisés selon les thématiques dominantes</h5>
                  <div class="alerteTableau pt-2 pb-2">
                    Ce tableau est en lien avec le tableau E.1 de l'onglet ‘E – Les aides apportées’
                  </div>
                  <div class="card-header text-muted">
                    <i>Indiquer le nombre d'entretiens réalisés au BAV par l'association durant l'année selon les thématiques dominantes<br>
                      Pour les entretiens portant sur plusieurs thématiques, comptabiliser uniquement la thématique qui a dominé
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th class="text-center align-middle">Thématiques dominantes</th>
                                <th class="text-center align-middle">Nombre d'entretiens réalisés au sein du BAV</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Dominante psychologique</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeEntretPsy" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Dominante juridique</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeEntretJur" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Dominante sociale</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeEntretSoc" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Dominante écoute et soutien</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeEntretEcout" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autre<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    label="bavEeEntretAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF30Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeEntretAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL</b>
                                  <span *ngIf="modeRendu.enModeSaisie$ | async">
                                    <button class="btn-info ml-1 mr-2"
                                      title="Calcul automatique du total à partir des données ventilées"
                                      (click)="calculTotalTableauBavF51(i)">
                                      <b><i>Calcul automatique</i></b>
                                    </button>
                                  </span>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavEeEntretTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF12Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF12Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF12Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <h5 class="mt-5 ml-2">F.5.2 - Les diligences au sein du BAV</h5>
                  <div class="alerteTableau pt-2 pb-2">
                    Ce tableau est en lien avec le tableau E.2 de l'onglet ‘E – Les aides apportées’
                  </div>
                  <div class="card-header text-muted">
                    <i>Indiquer le nombre de diligences effectuées par l'association durant l'année vers les dispositifs ou institutions indiquées
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th class="text-center align-middle">Diligences auprès de</th>
                                <th class="text-center align-middle">Nombre de diligences effectuées au sein du BAV</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La juridiction (sauf CIVI)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliJur" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La CIVI</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliCivi" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les fonds de garantie</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliFondGaran" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Le service d'aide au recouvrement des victimes d'infraction (SARVI)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliSarvi" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Le SPIP, les services pénitentiaires</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliPenit" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La police, la gendarmerie</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliPolgend" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Un avocat</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliAvoc" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Un commissaire de justice (ex Huissier)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliHuis" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les organismes sociaux (la sécurité sociale, la CAF…)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliOrgaSoc" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les mairies, collectivités locales, CCAS</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliColter" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La préfecture</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliPref" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Un organisme de logement</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliOrgaLogt" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Un lieu d'hébergement</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliHebgt" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les services médicaux et hospitaliers</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliHosto" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Une autre association</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliAsso" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les assurances</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliAssur" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les services d'accès au droit hors France services (point justice, maison de justice et du droit…)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliSad" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les France services</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliFrserv" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autres dispositifs ou institutions<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    label="bavEeDiliAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF32Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> Total des diligences effectuées</b>
                                  <span *ngIf="modeRendu.enModeSaisie$ | async">
                                    <button class="btn-info ml-1 mr-2"
                                      title="Calcul automatique du total à partir des données ventilées"
                                      (click)="calculTotalTableauBavF52(i)">
                                      <b><i>Calcul automatique</i></b>
                                    </button>
                                  </span>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavEeDiliTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF13Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF13Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF13Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <h5 class="mt-5 ml-2">F.5.3 - Les aides auprès de la CIVI et du SARVI au sein du BAV</h5>
                  <div class="alerteTableau pt-2 pb-2">
                    Ce tableau est en lien avec le tableau E.4 de l'onglet ‘E – Les aides apportées’
                  </div>
                  <div class="card-header text-muted">
                    <i>Indiquer le nombre de personnes reçues durant l'année pour une aide concernant la CIVI et le SARVI
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th class="text-center align-middle">Type d'aide apportée</th>
                                <th class="text-center align-middle">Nombre de personnes reçues au sein du BAV</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Aide à l'établissement de la requête devant la CIVI pour des dommages corporels et aux biens (706-3, 706-14 et 706-14-1 du CPP)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAideCivi" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlF32Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF32Bav">
                                  </bis-affiche-erreurs-croisees>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Aide à la constitution du dossier pour le SARVI</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAideSarvi" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlF33Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF33Bav">
                                  </bis-affiche-erreurs-croisees>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <h5 class="mt-5 ml-2">F.5.4 - Nombre d'informations communiquées aux victimes d'infractions pénales durant l'année au sein du BAV</h5>
                  <h6 class="mt-3 ml-2">a - Sur la procédure en cours</h6>
                  <div class="card-header text-muted">
                    <i>Indiquer le nombre d'informations communiquées aux victimes concernant la procédure selon la phase de celle-ci
                      <br>Plusieurs réponses possibles
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th colspan="2" class="text-center align-middle">a-1 - PHASE PRÉ-SENTENCIELLE</th>
                                <th colspan="2" class="text-center align-middle">a-2 - PHASE POST-SENTENCIELLE</th>
                              </tr>
                              <tr>
                                <th class="text-center align-middle">Informations communiquées portant sur</th>
                                <th class="text-center align-middle">Nombre d'informations</th>
                                <th class="text-center align-middle">Informations communiquées portant sur</th>
                                <th class="text-center align-middle">Nombre d'informations</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les modalités de la plainte</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPreSentenPlainte" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Le contenu de la décision</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPostSentenDec" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">L'enquête, les poursuites engagées, l'instruction en cours</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPreSentenEnq" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Le caractère définitif du jugement</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPostSentenDef" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Le classement sans suite</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPreSentenCss" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les modalités de recours</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPostSentenRecour" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La constitution de partie civile</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPreSentenPc" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">D'autres informations sur la procédure en cours en phase post-sentencielle (hors recouvrement des dommages et intérêts)<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                     label="bavEeProcPostSentenAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF41Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPostSentenAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La juridiction saisie et/ou le déroulé de l'audience</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPreSentenAud" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL</b>
                                  <span *ngIf="modeRendu.enModeSaisie$ | async">
                                    <button class="btn-info ml-1 mr-2"
                                      title="Calcul automatique du total à partir des données ventilées"
                                      (click)="calculTotalTableauBavF54a2(i)">
                                      <b><i>Calcul automatique</i></b>
                                    </button>
                                  </span>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavEeProcPostSentenTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF15Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF15Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF15Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">D'autres informations sur la procédure en cours en phase pré-sentencielle<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                     label="bavEeProcPreSentenAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF40Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPreSentenAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-right align-middle pl-2" style="width: 35%"></td>
                                <td class="text-right align-middle pl-2" style="width: 35%"></td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL</b>
                                  <span *ngIf="modeRendu.enModeSaisie$ | async">
                                    <button class="btn-info ml-1 mr-2"
                                      title="Calcul automatique du total à partir des données ventilées"
                                      (click)="calculTotalTableauBavF54a1(i)">
                                      <b><i>Calcul automatique</i></b>
                                    </button>
                                  </span>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavEeProcPreSentenTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF14Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF14Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF14Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-right align-middle pl-2" style="width: 35%"></td>
                                <td class="text-right align-middle pl-2" style="width: 35%"></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <h6 class="mt-5 ml-2">b - Sur la situation de l'auteur de l'infraction (plusieurs réponses possibles)</h6>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th colspan="2" class="text-center align-middle">b-1 - PHASE PRÉ-SENTENCIELLE</th>
                                <th colspan="2" class="text-center align-middle">b-2 - PHASE POST-SENTENCIELLE</th>
                              </tr>
                              <tr>
                                <th class="text-center align-middle">Informations communiquées portant sur</th>
                                <th class="text-center align-middle">Nombre d'informations</th>
                                <th class="text-center align-middle">Informations communiquées portant sur</th>
                                <th class="text-center align-middle">Nombre d'informations</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Le contrôle judiciaire</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPreSentenCj" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les mesures en milieu fermé (incarcération, remise de peine, permission de sortie...)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPostSentenMilFer" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La détention provisoire</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPreSentenDp" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les mesures en milieu ouvert (sursis probatoire, travail d'intérêt général, aménagement de peine, y compris DDSE...)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPostSentenMilOuv" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La fin de la détention</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPreSentenFinDeten" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">La fin de la détention</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPostSentenFinDeten" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La fin de la mesure</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPreSentenFinMes" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">La fin de la mesure</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPostSentenFinMes" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">
                                  <label mat-raised-button [matTooltip]="infobulle1" matTooltipClass="tooltip-large"
                                  matTooltipPosition="right">
                                  Autres (y compris ARSE<i class="material-icons md-light md-18" aria-hidden="true">
                                    info
                                  </i>
                                  </label>)
                                  <br><br><bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    label="bavEeAuteurPreSentenAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF42Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPreSentenAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autres<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                     label="bavEeAuteurPostSentenAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF43Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPostSentenAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL</b>
                                  <span *ngIf="modeRendu.enModeSaisie$ | async">
                                    <button class="btn-info ml-1 mr-2"
                                      title="Calcul automatique du total à partir des données ventilées"
                                      (click)="calculTotalTableauBavF54b1(i)">
                                      <b><i>Calcul automatique</i></b>
                                    </button>
                                  </span>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavEeAuteurPreSentenTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF16Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                      labelErreur="ctrlF16Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF16Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL</b>
                                  <span *ngIf="modeRendu.enModeSaisie$ | async">
                                    <button class="btn-info ml-1 mr-2"
                                      title="Calcul automatique du total à partir des données ventilées"
                                      (click)="calculTotalTableauBavF54b2(i)">
                                      <b><i>Calcul automatique</i></b>
                                    </button>
                                  </span>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavEeAuteurPostSentenTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF17Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                      labelErreur="ctrlF17Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF17Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <h6 class="mt-5 ml-2">c - Sur le recouvrement des dommages et intérêts (plusieurs réponses possibles)</h6>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th colspan="2" class="text-center align-middle">c-1 - PHASE PRÉ-SENTENCIELLE</th>
                                <th colspan="2" class="text-center align-middle">c-2 - PHASE POST-SENTENCIELLE</th>
                              </tr>
                              <tr>
                                <th class="text-center align-middle">Informations communiquées portant sur</th>
                                <th class="text-center align-middle">Nombre d'informations</th>
                                <th class="text-center align-middle">Informations communiquées portant sur</th>
                                <th class="text-center align-middle">Nombre d'informations</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La CIVI</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiPreSentenCivi" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">La CIVI</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiPostSentenCivi" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autres<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                     label="bavEeDiPreSentenAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF44Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiPreSentenAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Le SARVI</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiPostSentenSarvi" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL</b>
                                  <span *ngIf="modeRendu.enModeSaisie$ | async">
                                    <button class="btn-info ml-1 mr-2"
                                      title="Calcul automatique du total à partir des données ventilées"
                                      (click)="calculTotalTableauBavF54c1(i)">
                                      <b><i>Calcul automatique</i></b>
                                    </button>
                                  </span>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavEeDiPreSentenTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF18Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF18Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF18Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les Commissaires de justice (ex Huissiers)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiPostSentenHuis" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%"></td>
                                <td class="text-center align-middle pt-3" style="width: 15%"></td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Le JAP et le SPIP</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiPostSentenJapSpip" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%"></td>
                                <td class="text-center align-middle pt-3" style="width: 15%"></td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les Fonds de garantie</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiPostSentenFondGar" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%"></td>
                                <td class="text-center align-middle pt-3" style="width: 15%"></td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autres<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    label="bavEeDiPostSentenAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF45Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiPostSentenAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%"></td>
                                <td class="text-center align-middle pt-3" style="width: 15%"></td>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL</b>
                                  <span *ngIf="modeRendu.enModeSaisie$ | async">
                                    <button class="btn-info ml-1 mr-2"
                                      title="Calcul automatique du total à partir des données ventilées"
                                      (click)="calculTotalTableauBavF54c2(i)">
                                      <b><i>Calcul automatique</i></b>
                                    </button>
                                  </span>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavEeDiPostSentenTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF19Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF19Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF19Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <h6 class="mt-5 ml-2">d - Sur le fonctionnement judiciaire en général</h6>
                  <fieldset class="ml-2 mr-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row mt-2">
                        <div class="col-md-8">
                          <bis-integer-inline-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                            label="bavEeFoncJudic" classeColLabel="col-9" classeColInput="col-3"
                            classeSupplInput="text-left">
                          </bis-integer-inline-input-keypad>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <h5 class="mt-5 ml-2">F.5.5 - Les démarches spécifiques accomplies par le BAV</h5>
                  <div class="card-header text-muted">
                    <i>Indiquer le nombre de démarches spécifiques accomplies durant l'année
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2 pb-3">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th class="text-center align-middle">Type de démarches spécifiques</th>
                                <th class="text-center align-middle">Nombre de démarches spécifiques accomplies au sein du BAV</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Aide au dépôt de plainte
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDemarPlainte" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Aide à la constitution de dossiers d'aide juridictionnelle
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDemarAj" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Aide à la constitution du dossier en vue de l'audience
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDemarAud" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Accompagnement physique aux audiences
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDemarAccomp" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Aide à la constitution du dossier d'indemnisation
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDemarDi" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autres démarches spécifiques accomplies<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    label="bavEeDemarAutrDet" longueurMax=150>
                                   </bis-string-input>
                                   <bis-affiche-alertes [labelAlerte]="'alertF48Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDemarAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL</b>
                                  <span *ngIf="modeRendu.enModeSaisie$ | async">
                                    <button class="btn-info ml-1 mr-2"
                                      title="Calcul automatique du total à partir des données ventilées"
                                      (click)="calculTotalTableauBavF55(i)">
                                      <b><i>Calcul automatique</i></b>
                                    </button>
                                  </span>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavEeDemarTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF20Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                        labelErreur="ctrlF20Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF20Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>
              </mat-expansion-panel>
            </div>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Impression (sans les mat-accordion)-->
<div *ngIf="detailBavs && (modeRendu.enModeImpression$ | async)">
  <div class="body">
    <div class="form-row mx-2 pb-3" *ngIf="detailBavs">
      <div class="col" [formGroup]="rootForm">
        <p class="titreBav mx-1 mt-3">Nombre de BAV actuellement : <b>{{detailBavs.length}}</b></p>
        <div>
            <div *ngFor="let item of detailBavs.controls; let i = index">
                <div style="page-break-before: always" *ngIf="i !== 0"></div>

                <span class="bavImpression" *ngIf="detailBavs.controls[i].get('bavIelst').value">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>{{ this.gestionLibelle(detailBavs.controls[i].get('bavIelst').value) }}</b>
                </span>
                 <h4 class="ml-2 pt-3">F.1 - Les moyens (BAV)</h4>
                  <h5 class="mt-4 ml-2">F.1.1 - Les personnels de l'association en charge des activités de l'Aide Aux
                    Victimes (tous dispositifs AAV)</h5>
                  <div class="alerteTableau pt-2 pb-2">
                    Ce tableau est en lien avec les tableaux A.1.a, A.1.b, A.1.c de la section A.1 de l'onglet ‘A – Les moyens’
                  </div>
                  <div class="card-header text-muted">
                    <i>Renseigner, pour chacune des fonctions, et selon le statut des personnels AAV, le nombre de
                      personnes en poste au 31 décembre ainsi que leur temps
                      de travail en équivalent temps plein travaillé (ETPT) sur l'année
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th rowspan="2" class="text-center align-middle">Fonction</th>
                                <th colspan="2" class="text-center align-middle">au sein du BAV</th>
                              </tr>
                              <tr>
                                <th class="text-center align-middle">Effectif 31/12</th>
                                <th class="text-center align-middle">ETPT</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Accueillants Aide aux
                                  victimes</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="999"
                                    label="bavAaNbAav" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-float-mask-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" 
                                      separatorLimit="999" libelle="vide" 
                                      label="bavAaEtpAav"
                                      classeSupplInput="text-right">
                                  </bis-float-mask-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Juristes</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="999"
                                    label="bavAaNbJur" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-float-mask-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" 
                                      separatorLimit="999" libelle="vide" 
                                      label="bavAaEtpJur"
                                      classeSupplInput="text-right">
                                  </bis-float-mask-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Psychologues</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="999"
                                    label="bavAaNbPsy" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-float-mask-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" 
                                      separatorLimit="999" libelle="vide" 
                                      label="bavAaEtpPsy"
                                      classeSupplInput="text-right">
                                  </bis-float-mask-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Travailleurs sociaux</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="999"
                                    label="bavAaNbWsoc" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-float-mask-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" 
                                      separatorLimit="999" libelle="vide" 
                                      label="bavAaEtpWsoc"
                                      classeSupplInput="text-right">
                                  </bis-float-mask-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autres intervenants</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="999"
                                    label="bavAaNbAutrInterv" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-float-mask-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" 
                                      separatorLimit="999" libelle="vide" 
                                      label="bavAaEtpAutrInterv"
                                      classeSupplInput="text-right">
                                  </bis-float-mask-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Directeur, chef de service
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="999"
                                    label="bavAaNbDir" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-float-mask-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" 
                                      separatorLimit="999" libelle="vide" 
                                      label="bavAaEtpDir"
                                      classeSupplInput="text-right">
                                  </bis-float-mask-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Comptable, secrétaire,
                                  personnel d'entretien</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="999"
                                    label="bavAaNbComptsecr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-float-mask-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" 
                                      separatorLimit="999" libelle="vide" 
                                      label="bavAaEtpComptsecr"
                                      classeSupplInput="text-right">
                                  </bis-float-mask-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autres fonctions
                                  transversales et de support (ex : informaticien)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="999"
                                    label="bavAaNbAutrSupport" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-float-mask-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" 
                                      separatorLimit="999" libelle="vide" 
                                      label="bavAaEtpAutrSupport"
                                      classeSupplInput="text-right">
                                  </bis-float-mask-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL des personnels du BAV</b>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="9999"
                                    label="bavAaNbTot" classeSupplementaire="integer-input-total text-right"
                                    libelle="vide" [erreursCroisees]="['ctrlF1Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                     labelErreur="ctrlF1Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF1Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-float-mask-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" 
                                      separatorLimit="9999" libelle="vide" 
                                      label="bavAaEtpTot"
                                      classeSupplInput="integer-input-total text-right" [erreursCroisees]="['ctrlF2Bav']">
                                  </bis-float-mask-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF2Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF2Bav_' + i"></bis-affiche-alertes>
                                  <bis-affiche-alertes [labelAlerte]="'alertF49Bav_' + i"></bis-affiche-alertes>
                                 </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <div style="page-break-before: always"></div>

                  <h4 class="ml-2 mt-5">F.2 - Les premiers contacts (BAV)</h4>
                  <h5 class="mt-4 ml-2">F.2.1 - L'origine du premier contact (victime ou non)</h5>
                  <div class="alerteTableau pt-2 pb-2">
                    Ce tableau est en lien avec le tableau B.1 de l'onglet ‘B – Les premiers contacts’
                  </div>
                  <div class="card-header text-muted">
                    <i>Indiquer le nombre de personnes en contact avec l'association au sein du BAV pour la première
                      fois au cours de l'année, <u>qu'elles soient ou non victimes</u>, selon l'origine du premier
                      contact
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th class="text-center align-middle">Origine du contact</th>
                                <th class="text-center align-middle">au sein du BAV</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Démarche pro-active de
                                  l'association vers la personne</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavBbPremContactOrigAsso" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">A l'initiative de la personne
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavBbPremContactOrigPerso" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL du BAV</b>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavBbPremContactOrigTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF3Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF3Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF3Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <h5 class="mt-5 ml-2">F.2.2 - Le mode de premier contact (victime ou non)</h5>
                  <div class="alerteTableau pt-2 pb-2">
                    Ce tableau est en lien avec le tableau B.2 de l'onglet ‘B – Les premiers contacts’
                  </div>
                  <div class="card-header text-muted">
                    <i>Indiquer le nombre de personnes en contact avec l'association pour la première fois au cours de
                      l'année, <u>qu'elles soient ou non victimes</u>, selon le mode de premier contact
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th class="text-center align-middle">Mode de contact</th>
                                <th class="text-center align-middle">au sein du BAV</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Courrier, courriel ou fax
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavBbPremContactModeEcrit" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Appel téléphonique</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavBbPremContactModeTel" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Présentation à la permanence
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavBbPremContactModePres" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL du BAV</b>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavBbPremContactModeTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF4Bav', 'ctrlF23Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF4Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF23Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF4Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <div style="page-break-before: always"></div>

                  <h4 class="ml-2 mt-5">F.3 - Les personnes reçues (BAV)</h4>
                  <h5 class="mt-4 ml-2">F.3.1 - Personnes reçues pour soutien et accompagnement</h5>
                  <div class="alerteTableau pt-2 pb-2">
                    Ce tableau est en lien avec le tableau C.1 de l'onglet ‘C – Les personnes reçues’
                  </div>
                  <div class="card-header text-muted">
                    <i>Indiquer le nombre de personnes reçues selon la nature des faits
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th rowspan="2" class="text-center align-middle">Nature des faits</th>
                                <th colspan="3" class="text-center align-middle">Au sein du BAV</th>
                              </tr>
                              <tr>
                                <th class="text-center align-middle">Nombre de personnes reçues</th>
                                <th class="text-center align-middle">Dont accompagnées (au moins 2 entretiens)</th>
                                <th class="text-center align-middle">Nombre d'entretiens réalisés</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Faits pouvant avoir une
                                  qualification pénale</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavCcRecuVictNb" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavCcRecuVictSuivi" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlF24Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF24Bav">
                                  </bis-affiche-erreurs-croisees>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavCcRecuVictEntret" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlF26Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF26Bav">
                                  </bis-affiche-erreurs-croisees>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Faits n'ayant pas une
                                  qualification pénale</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavCcRecuNvictNb" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavCcRecuNvictSuivi" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlF25Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF25Bav">
                                  </bis-affiche-erreurs-croisees>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavCcRecuNvictEntret" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlF27Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF27Bav">
                                  </bis-affiche-erreurs-croisees>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL</b>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavCcRecuNbTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF5Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF5Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF5Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavCcRecuSuiviTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF6Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF6Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF6Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavCcRecuEntretTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF7Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF7Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF7Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <h5 class="mt-5 ml-2">F.3.2 - Nombre de victimes <u>d'infractions pénales</u> reçues au BAV</h5>
                  <div class="alerteTableau pt-2 pb-2">
                    Ce tableau est en lien avec le tableau C.2 de l'onglet ‘C – Les personnes reçues’
                  </div>
                  <div class="card-header text-muted">
                    <i>Indiquer le nombre de victimes reçues selon les précisions demandées
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row mt-2">
                        <div class="col-md-10">
                          <bis-integer-inline-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                            label="bavCcRecuVict" classeColLabel="col-6" classeLabelErreur="col-3" classeColInput="col-3"
                            classeSupplInput="text-right" [erreursCroisees]="['ctrlF28Bav']">
                          </bis-integer-inline-input-keypad>
                          <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                            labelErreur="ctrlF28Bav">
                          </bis-affiche-erreurs-croisees>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                          <bis-integer-inline-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                            label="bavCcRecuVictPc" classeColLabel="col-9" classeColInput="col-3"
                            classeSupplInput="text-right" [erreursCroisees]="['ctrlF29Bav']">
                          </bis-integer-inline-input-keypad>
                          <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                            labelErreur="ctrlF29Bav">
                          </bis-affiche-erreurs-croisees>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                          <bis-integer-inline-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                            label="bavCcRecuVictAud" classeColLabel="col-9" classeColInput="col-3"
                            classeSupplInput="text-right" [erreursCroisees]="['ctrlF30Bav']">
                          </bis-integer-inline-input-keypad>
                          <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                            labelErreur="ctrlF30Bav">
                          </bis-affiche-erreurs-croisees>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <div style="page-break-before: always"></div>

                  <h4 class="ml-2 mt-5">F.4 - Contexte juridique des faits pour les victimes d'infractions pénales</h4>
                  <div class="alerteTableau pt-2">
                    Ce tableau est en lien avec le tableau D.1 de l'onglet ‘D – Les faits – procédure’
                  </div>
                  <div class="card-header text-muted mt-3">
                    <i>Indiquer la qualification pénale des faits pour lesquels la victime a été reçue durant
                      l'année<br>
                      En cas d'infractions multiples ne retenir que l'infraction principale subie par la victime
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th class="text-center align-middle">Infractions selon le contexte des faits</th>
                                <th class="text-center align-middle">Nombre de victimes reçues au sein du BAV</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%"><b>1 - Atteintes aux
                                    personnes (hors accidents de la circulation)</b></td>
                                <td class="text-center align-middle pt-3" style="width: 15%"></td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Homicides volontaires</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoHomiVolo" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Infractions à caractère
                                  sexuel (viols, agressions sexuelles, atteintes et harcèlements sexuels)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoSexuel" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Proxénétisme</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoProxe" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Violences volontaires</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoViolen" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Homicides involontaires</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoHomiInvolo" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Blessures involontaires</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoBless" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Abandons de famille (non
                                  paiement de la CEE, non représentation d'enfants...)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoAband" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Menaces, injures, harcèlement
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoMenace" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Discriminations</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoDiscri" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autre(s)<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    label="bavDdFaitPersoAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF26Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitPersoAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> Total atteintes aux personnes</b>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavDdFaitPersoTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF8Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF8Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF8Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%"><b>2 - Atteintes aux biens
                                    (hors accidents de la circulation)</b></td>
                                <td class="text-center align-middle pt-3" style="width: 15%"></td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Vol simple</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitBienVolSimp" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Vol aggravé</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitBienVolAggr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Abus de confiance,
                                  escroquerie</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitBienEscro" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Destruction, dégradation</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitBienDegrad" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autre(s)<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    label="bavDdFaitBienAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF27Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitBienAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> Total atteintes aux biens</b>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavDdFaitBienTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF9Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF9Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF9Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%"><b>3 - Accidents de la circulation</b></td>
                                <td class="text-center align-middle pt-3" style="width: 15%"></td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Homicides involontaires, blessures involontaires</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitCircuBless" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Dégâts matériels uniquement</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitCircuDegat" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> Total accidents de la circulation</b>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavDdFaitCircuTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF10Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF10Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF10Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%"><b>4 - Autres infractions</b><br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    label="bavDdFaitAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF28Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavDdFaitAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> Total des victimes reçues</b>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavDdFaitTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF11Bav', 'ctrlF31Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF11Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF31Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF11Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <div style="page-break-before: always"></div>

                  <h4 class="ml-2 mt-5">F.5 - Les aides apportées par l'association</h4>
                  <h5 class="mt-4 ml-2">F.5.1 - Les entretiens réalisés selon les thématiques dominantes</h5>
                  <div class="alerteTableau pt-2 pb-2">
                    Ce tableau est en lien avec le tableau E.1 de l'onglet ‘E – Les aides apportées’
                  </div>
                  <div class="card-header text-muted">
                    <i>Indiquer le nombre d'entretiens réalisés au BAV par l'association durant l'année selon les thématiques dominantes<br>
                      Pour les entretiens portant sur plusieurs thématiques, comptabiliser uniquement la thématique qui a dominé
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th class="text-center align-middle">Thématiques dominantes</th>
                                <th class="text-center align-middle">Nombre d'entretiens réalisés au sein du BAV</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Dominante psychologique</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeEntretPsy" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Dominante juridique</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeEntretJur" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Dominante sociale</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeEntretSoc" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Dominante écoute et soutien</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeEntretEcout" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autre<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    label="bavEeEntretAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF30Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeEntretAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL</b>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavEeEntretTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF12Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF12Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF12Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <div style="page-break-before: always"></div>

                  <h5 class="mt-5 ml-2">F.5.2 - Les diligences au sein du BAV</h5>
                  <div class="alerteTableau pt-2 pb-2">
                    Ce tableau est en lien avec le tableau E.2 de l'onglet ‘E – Les aides apportées’
                  </div>
                  <div class="card-header text-muted">
                    <i>Indiquer le nombre de diligences effectuées par l'association durant l'année vers les dispositifs ou institutions indiquées
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th class="text-center align-middle">Diligences auprès de</th>
                                <th class="text-center align-middle">Nombre de diligences effectuées au sein du BAV</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La juridiction (sauf CIVI)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliJur" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La CIVI</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliCivi" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les fonds de garantie</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliFondGaran" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Le service d'aide au recouvrement des victimes d'infraction (SARVI)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliSarvi" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Le SPIP, les services pénitentiaires</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliPenit" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La police, la gendarmerie</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliPolgend" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Un avocat</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliAvoc" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Un commissaire de justice (ex Huissier)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliHuis" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les organismes sociaux (la sécurité sociale, la CAF…)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliOrgaSoc" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les mairies, collectivités locales, CCAS</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliColter" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La préfecture</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliPref" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Un organisme de logement</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliOrgaLogt" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Un lieu d'hébergement</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliHebgt" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les services médicaux et hospitaliers</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliHosto" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Une autre association</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliAsso" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les assurances</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliAssur" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les services d'accès au droit hors France services (point justice, maison de justice et du droit…)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliSad" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les France services</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliFrserv" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autres dispositifs ou institutions<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    label="bavEeDiliAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF32Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiliAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> Total des diligences effectuées</b>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavEeDiliTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF13Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF13Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF13Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <div style="page-break-before: always"></div>

                  <h5 class="mt-5 ml-2">F.5.3 - Les aides auprès de la CIVI et du SARVI au sein du BAV</h5>
                  <div class="alerteTableau pt-2 pb-2">
                    Ce tableau est en lien avec le tableau E.4 de l'onglet ‘E – Les aides apportées’
                  </div>
                  <div class="card-header text-muted">
                    <i>Indiquer le nombre de personnes reçues durant l'année pour une aide concernant la CIVI et le SARVI
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th class="text-center align-middle">Type d'aide apportée</th>
                                <th class="text-center align-middle">Nombre de personnes reçues au sein du BAV</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Aide à l'établissement de la requête devant la CIVI pour des dommages corporels et aux biens (706-3, 706-14 et 706-14-1 du CPP)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAideCivi" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlF32Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF32Bav">
                                  </bis-affiche-erreurs-croisees>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Aide à la constitution du dossier pour le SARVI</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAideSarvi" classeSupplementaire="text-right" libelle="vide" [erreursCroisees]="['ctrlF33Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF33Bav">
                                  </bis-affiche-erreurs-croisees>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <div style="page-break-before: always"></div>

                  <h5 class="mt-5 ml-2">F.5.4 - Nombre d'informations communiquées aux victimes d'infractions pénales durant l'année au sein du BAV</h5>
                  <h6 class="mt-3 ml-2">a - Sur la procédure en cours</h6>
                  <div class="card-header text-muted">
                    <i>Indiquer le nombre d'informations communiquées aux victimes concernant la procédure selon la phase de celle-ci
                      <br>Plusieurs réponses possibles
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th colspan="2" class="text-center align-middle">a-1 - PHASE PRÉ-SENTENCIELLE</th>
                                <th colspan="2" class="text-center align-middle">a-2 - PHASE POST-SENTENCIELLE</th>
                              </tr>
                              <tr>
                                <th class="text-center align-middle">Informations communiquées portant sur</th>
                                <th class="text-center align-middle">Nombre d'informations</th>
                                <th class="text-center align-middle">Informations communiquées portant sur</th>
                                <th class="text-center align-middle">Nombre d'informations</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les modalités de la plainte</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPreSentenPlainte" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Le contenu de la décision</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPostSentenDec" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">L'enquête, les poursuites engagées, l'instruction en cours</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPreSentenEnq" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Le caractère définitif du jugement</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPostSentenDef" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Le classement sans suite</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPreSentenCss" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les modalités de recours</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPostSentenRecour" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La constitution de partie civile</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPreSentenPc" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">D'autres informations sur la procédure en cours en phase post-sentencielle (hors recouvrement des dommages et intérêts)<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                     label="bavEeProcPostSentenAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF41Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPostSentenAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La juridiction saisie et/ou le déroulé de l'audience</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPreSentenAud" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL</b>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavEeProcPostSentenTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF15Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF15Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF15Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">D'autres informations sur la procédure en cours en phase pré-sentencielle<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                     label="bavEeProcPreSentenAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF40Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeProcPreSentenAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-right align-middle pl-2" style="width: 35%"></td>
                                <td class="text-right align-middle pl-2" style="width: 35%"></td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL</b>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavEeProcPreSentenTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF14Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF14Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF14Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-right align-middle pl-2" style="width: 35%"></td>
                                <td class="text-right align-middle pl-2" style="width: 35%"></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <div style="page-break-before: always"></div>

                  <h6 class="mt-5 ml-2">b - Sur la situation de l'auteur de l'infraction (plusieurs réponses possibles)</h6>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th colspan="2" class="text-center align-middle">b-1 - PHASE PRÉ-SENTENCIELLE</th>
                                <th colspan="2" class="text-center align-middle">b-2 - PHASE POST-SENTENCIELLE</th>
                              </tr>
                              <tr>
                                <th class="text-center align-middle">Informations communiquées portant sur</th>
                                <th class="text-center align-middle">Nombre d'informations</th>
                                <th class="text-center align-middle">Informations communiquées portant sur</th>
                                <th class="text-center align-middle">Nombre d'informations</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Le contrôle judiciaire</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPreSentenCj" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les mesures en milieu fermé (incarcération, remise de peine, permission de sortie...)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPostSentenMilFer" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La détention provisoire</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPreSentenDp" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les mesures en milieu ouvert (sursis probatoire, travail d'intérêt général, aménagement de peine, y compris DDSE...)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPostSentenMilOuv" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La fin de la détention</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPreSentenFinDeten" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">La fin de la détention</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPostSentenFinDeten" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La fin de la mesure</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPreSentenFinMes" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">La fin de la mesure</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPostSentenFinMes" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">
                                  <label mat-raised-button [matTooltip]="infobulle1" matTooltipClass="tooltip-large"
                                  matTooltipPosition="right">
                                  <b>Autres (y compris ARSE</b><i class="material-icons md-light md-18" aria-hidden="true">
                                    info
                                  </i>
                                  </label>)
                                  <br><br><bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    label="bavEeAuteurPreSentenAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF42Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPreSentenAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autres<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                     label="bavEeAuteurPostSentenAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF43Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeAuteurPostSentenAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL</b>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavEeAuteurPreSentenTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF16Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                      labelErreur="ctrlF16Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF16Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL</b>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavEeAuteurPostSentenTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF17Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                      labelErreur="ctrlF17Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF17Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <div style="page-break-before: always"></div>

                  <h6 class="mt-5 ml-2">c - Sur le recouvrement des dommages et intérêts (plusieurs réponses possibles)</h6>
                  <fieldset class="ml-2 mr-2 pt-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th colspan="2" class="text-center align-middle">c-1 - PHASE PRÉ-SENTENCIELLE</th>
                                <th colspan="2" class="text-center align-middle">c-2 - PHASE POST-SENTENCIELLE</th>
                              </tr>
                              <tr>
                                <th class="text-center align-middle">Informations communiquées portant sur</th>
                                <th class="text-center align-middle">Nombre d'informations</th>
                                <th class="text-center align-middle">Informations communiquées portant sur</th>
                                <th class="text-center align-middle">Nombre d'informations</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">La CIVI</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiPreSentenCivi" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">La CIVI</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiPostSentenCivi" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autres<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                     label="bavEeDiPreSentenAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF44Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiPreSentenAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Le SARVI</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiPostSentenSarvi" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL</b>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavEeDiPreSentenTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF18Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF18Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF18Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les Commissaires de justice (ex Huissiers)</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiPostSentenHuis" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%"></td>
                                <td class="text-center align-middle pt-3" style="width: 15%"></td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Le JAP et le SPIP</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiPostSentenJapSpip" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%"></td>
                                <td class="text-center align-middle pt-3" style="width: 15%"></td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Les Fonds de garantie</td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiPostSentenFondGar" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%"></td>
                                <td class="text-center align-middle pt-3" style="width: 15%"></td>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autres<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    label="bavEeDiPostSentenAutrDet" longueurMax=150>
                                  </bis-string-input>
                                  <bis-affiche-alertes [labelAlerte]="'alertF45Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDiPostSentenAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%"></td>
                                <td class="text-center align-middle pt-3" style="width: 15%"></td>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL</b>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavEeDiPostSentenTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF19Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                    labelErreur="ctrlF19Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF19Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <h6 class="mt-5 ml-2">d - Sur le fonctionnement judiciaire en général</h6>
                  <fieldset class="ml-2 mr-2">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row mt-2">
                        <div class="col-md-8">
                          <bis-integer-inline-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                            label="bavEeFoncJudic" classeColLabel="col-9" classeColInput="col-3"
                            classeSupplInput="text-left">
                          </bis-integer-inline-input-keypad>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <div style="page-break-before: always"></div>

                  <h5 class="mt-5 ml-2">F.5.5 - Les démarches spécifiques accomplies par le BAV</h5>
                  <div class="card-header text-muted">
                    <i>Indiquer le nombre de démarches spécifiques accomplies durant l'année
                    </i>
                  </div>
                  <fieldset class="ml-2 mr-2 pt-2 pb-3">
                    <div class="card rounded bg-light shadow" style="border-width:2px">
                      <div class="form-row">
                        <div class="col-md-12">
                          <table id="table-C1" class="table table-sm m-0 table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th class="text-center align-middle">Type de démarches spécifiques</th>
                                <th class="text-center align-middle">Nombre de démarches spécifiques accomplies au sein du BAV</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Aide au dépôt de plainte
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDemarPlainte" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Aide à la constitution de dossiers d'aide juridictionnelle
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDemarAj" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Aide à la constitution du dossier en vue de l'audience
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDemarAud" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Accompagnement physique aux audiences
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDemarAccomp" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Aide à la constitution du dossier d'indemnisation
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDemarDi" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-left align-middle pl-2" style="width: 35%">Autres démarches spécifiques accomplies<br><br>
                                  <bis-string-input [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    label="bavEeDemarAutrDet" longueurMax=150>
                                   </bis-string-input>
                                   <bis-affiche-alertes [labelAlerte]="'alertF48Bav_' + i"></bis-affiche-alertes>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i" [max]="99999"
                                    label="bavEeDemarAutr" classeSupplementaire="text-right" libelle="vide">
                                  </bis-integer-input-keypad>
                                </td>
                              </tr>
                              <tr>
                                <td class="text-right align-middle pl-2" style="width: 35%">
                                  <b> TOTAL</b>
                                </td>
                                <td class="text-center align-middle pt-3" style="width: 15%">
                                  <bis-integer-input-keypad [rootForm]="detailBavs.controls[i]" [preId]="i"
                                    [max]="999999" label="bavEeDemarTot"
                                    classeSupplementaire="integer-input-total text-right" libelle="vide" [erreursCroisees]="['ctrlF20Bav']">
                                  </bis-integer-input-keypad>
                                  <bis-affiche-erreurs-croisees [rootForm]="detailBavs.controls[i]" colorErreur="danger"
                                        labelErreur="ctrlF20Bav">
                                  </bis-affiche-erreurs-croisees>
                                  <bis-affiche-alertes [labelAlerte]="'alertF20Bav_' + i"></bis-affiche-alertes>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </fieldset>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>